import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { deleteAuthCookies } from '../../utils/auth';
import './style.scss';

const AILandingPageBuilder = () => {
    const { id } = useParams();

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const error = queryParams.get('error');

        if (error === 'unauthorized') {
            // Token was rejected by the microservice backend. Clear it and redirect to login page.
            deleteAuthCookies();
            window.location.href = '/sign-in';
            return;
        }

        const token = Cookies.get('token');
        if (!token) {
            // No token found, redirect to sign-in
            window.location.href = '/sign-in';
            return;
        }

        const targetUrl = process.env.REACT_APP_SVC_LP_AI_URL || 'http://localhost:8080';

        // Redirect to /builder/:id if ID is provided, otherwise /
        const nextPath = id ? `/builder/${id}` : '/';

        // Securely pass token via auth-callback
        const redirectUrl = `${targetUrl}/auth-callback?token=${encodeURIComponent(token)}&next=${encodeURIComponent(nextPath)}`;

        // Brief delay to allow the "premium" transition UI to be seen
        const timer = setTimeout(() => {
            window.location.href = redirectUrl;
        }, 1500);

        return () => clearTimeout(timer);
    }, [id]);

    return (
        <div className="lp-ai-loader">
            <svg className="lp-ai-loader__logo" viewBox="0 0 133.95 108" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path className="lp-ai-loader__logo-path--blue" d="M93.13,98.8l4.65-30.6c1.41-9.18,3.32-20.67,6.03-34.76h-0.39c-4.98,12.64-10.29,24.95-14.39,33.65 l-13.6,29.87H58.87l-1.41-29.8c-0.41-8.3-1-20.81-1.16-33.72h-0.26c-2.71,13.12-5.22,25.65-7.35,34.76l-7.13,30.6H22.2l22.22-88.72 H71.8l0.99,29.88c0.27,7.97,1.02,18.72,0.89,28.43h0.47c3.18-9.72,7.83-20.82,11.23-28.57l12.6-29.74h27.53L113.44,98.8H93.13z" />
                    <path className="lp-ai-loader__logo-path--pink" d="M71.79,9.95H7.71c0,0,53.79,15.63,65.33,35.72L71.79,9.95z" />
                </g>
            </svg>

            <h2 className="lp-ai-loader__title">
                Menyiapkan AI Landing Page Builder
            </h2>
            <p className="lp-ai-loader__subtitle">
                Mohon tunggu sejenak, kami sedang menghubungkan sesi Anda...
            </p>
        </div>
    );
};

export default AILandingPageBuilder;
